// CLI v0.8 — `cloudgrid secrets …` subcommand group. Spec v17 §13.9.

import { Command } from 'commander';
import { secretsListCommand } from './list.js';
import { secretsGetCommand } from './get.js';
import { secretsSetCommand } from './set.js';
import { secretsUnsetCommand } from './unset.js';

export const secretsCommand = new Command('secrets')
  .description('Manage runtime secrets (K8s Secret-backed; values never returned to the CLI)')
  .addCommand(secretsListCommand)
  .addCommand(secretsGetCommand)
  .addCommand(secretsSetCommand)
  .addCommand(secretsUnsetCommand);
